'use strict';

/**
 * Provide methods to deal with type elements
 */
export var TypeUtils = {

    /**
     * Check whether value is a number
     * @param n
     * @returns {boolean}
     */
    isNumber : function(obj) {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
    },

    /**
     * Check whether value is a function
     * @param obj
     * @returns {boolean}
     */
    isFunction : function(obj) {
        return (typeof (obj) == 'function');
    },

    // ----------------------------------------------------------------------

    /**
     * Check whether obj is Empty depending of its type.
     * Results :
     *         []        true, empty array
     *         {}        true, empty object
     *         null      true
     *         undefined true
     *         ""        true, empty string
     *         ''        true, empty string
     *         0         false, number
     *         true      false, boolean
     *         false     false, boolean
     *         Date      false
     *         function  false
     * @param obj object
     */
    isEmpty : function(obj){
        if (obj === undefined)
            return true;

        if (typeof (obj) == 'function' || typeof (obj) == 'number' || typeof (obj) == 'boolean' || Object.prototype.toString.call(obj) === '[object Date]')
            return false;

        if (obj == null || obj.length === 0)
            return true;

        // empty object
        if (typeof (obj) == "object") {
            for (var f in obj)
                return false;

            return true;
        }

        return false;
    },

    /**
     * Fom object, get property value given by path. Example : getValue(o, "x.y.z") will return o.x.y.z property.
     * @param obj
     * @param path
     * @returns {*}
     */
    getValue : function(obj, path){
        if (obj == undefined || path == undefined) return undefined;
        var properties = path.split(".");

        var o = obj;
        for(var i=0; i<properties.length; i++) {
            if (TypeUtils.isEmpty(o)) return undefined;
            o = o[properties[i]];
        }

        return o;
    }
}
